import "./FormStyles.css"

import React, { useRef, useState } from 'react'

import {FaHome, FaPhone, FaMailBulk,FaBuilding} from "react-icons/fa"
import { useTranslation } from "react-i18next"
import emailjs from 'emailjs-com'

const Form = () =>{
  const form = useRef()
  const { t } = useTranslation()
  const [name,setName] = useState('')
  const [phone,setPhone] = useState('')
  const [email,setEmail] = useState('')
  const [subject,setSubject] = useState('')
  const [message,setMessage] = useState('')
  const [result,showResult] = useState(false)

  const sendEmail =(e) =>{
          e.preventDefault();
          emailjs.sendForm('service_vd9j6bi','template_xphhf02',form.current,'yhFzYOocgyqJMmUpC')
          .then((result) => {
            console.log(result.text);
            setName('');
            setPhone('');
            setEmail('');
            setSubject('');
            setMessage('');
            showResult(true);
          },(error) => {
            console.log(error.text);
            showResult(false);
          });         
  }

  //hide result 
  setTimeout(() => {
    showResult(false)
  },40000);

  return (
    <section className="contact-section" id="contact-section">
      <div className="form-container">
        <h1 className="form-heading">{t('contact.title')}</h1>
        <hr className="small-hr"></hr>
        <div className="form-card">
            <div className="form-left">
                <p><FaHome size={20} style={{color:"#000", marginRight:"2rem"}}></FaHome>10th F, 200 Consilium Pl, Scarborough,ON M1H 3G2, Canada</p> 
                <p><FaPhone size={20} style={{color:"#000", marginRight:"2rem"}}></FaPhone>+1-647-503-7066</p> 
                <p><FaMailBulk size={20} style={{color:"#000", marginRight:"2rem"}}></FaMailBulk>oseelight@gmail.com</p> 
                <p><FaBuilding size={20} style={{color:"#000", marginRight:"2rem"}}></FaBuilding>O See Light Technology Inc.</p> 
            </div>
            <div className="form">
                <form ref={form} onSubmit={sendEmail} results="false">
                  <div>
                    {/*<label>Your Name</label>*/}
                    <input 
                        type="text" 
                        name="name" 
                        className="form-control"
                        placeholder={t('contact.form.name')} 
                        value={name} 
                        onChange={(e) => setName(e.target.value)} 
                        required>
                      </input>
                      <input 
                        type="number" 
                        name="phone" 
                        className="form-control"
                        placeholder={t('contact.form.phone')}
                        value={phone} 
                        onChange={(e) => setPhone(e.target.value)} 
                        required>
                      </input>
                  </div>
                  <div>
                    {/* <label>Email</label> */}
                    <input 
                        type="email" 
                        name="email" 
                        className="form-control"
                        placeholder={t('contact.form.email')} 
                        value={email} 
                        onChange={(e) => setEmail(e.target.value)} 
                        required>
                    </input>
                    {/* <label>Subject</label> */}
                    <input 
                        type="text" 
                        name="subject"
                        className="form-control" 
                        placeholder={t('contact.form.subject')}
                        value={subject} 
                        onChange={(e) => setSubject(e.target.value)} 
                        required>
                    </input>
                    </div>
                    {/* <label>Message</label> */}
                    <textarea className="form-control" row="8" id="message" name="message" placeholder={t('contact.form.message')} value={message} onChange={(e) => setMessage(e.target.value)} required></textarea>
                    <button type="submit" className="btn">{t('contact.submit')} </button>
                    <div className="show-result" >{ result ?  <p>{t('show-result.part1') }</p> : null }</div>
                </form>
            </div>
        </div>  
      </div>
    </section>
  )
}

export default Form
